import Library from 'library'

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [Library.Store.Plugins.Persist('PlasticCollections-Admin')],

  modules: {
    auth: Library.Store.Modules.Auth(),
    metadata: Library.Store.Modules.MetaData(Library.Entities.getMetaDataEntities())
  }
})
